import { FilterGroup } from '../Tools/FilterGroup';
import { MagicSearchFilter } from '../Filters/MagicSearchFilter';
import { ShowUnavailableFilter } from '../Filters/ShowUnavailableFilter';
import { ShowForGraphicArtistsFilter } from '../Filters/ShowForGraphicArtistsFilter';
import { UniversesFilter } from '../Filters/UniversesFilter';
import { IFilter } from '../Tools/IFilter';
import { FiltersController } from '../Tools/FiltersController';

export class MagicSearchFilterWidget extends FilterGroup {

    constructor(container: string) {
        super();
        this.id = 'magicsearch';
        this.name = 'Recherche intelligente';
        this.icon = 'fas fa-lg fa-search-plus';
        this.resource = 'magicsearch';
        this.filtersFunction = 'updateFilters';
        this.universes = {
            indoor: false,
            bathroom: false,
            outdoor: false,
            junior: false,
            B2B: FilterGroup.mdmBusiness
        };
        this.filters = [
            new MagicSearchFilter(this),
            new ShowUnavailableFilter(this, true, false, 2),
            new ShowForGraphicArtistsFilter(this, false, true, 2),
            new UniversesFilter(this)
        ];
        this.controller = new FiltersController();

        this.filtersHtml = () => {
            let MagicSearchFilterWidgetHtml = '';
            this.filters.forEach((filter: IFilter) => {
                MagicSearchFilterWidgetHtml += `${filter.html()}`;
            });
            return MagicSearchFilterWidgetHtml;
        }
        this.container = container;
    }

    generateStringFilter() {
        let stringFilters = '&q.pipeline.modelState.eq=validated';

        this.filters.forEach((filter: IFilter) => {
            stringFilters += filter.generateStringFilter();
        });

        return stringFilters;
    };

    destroy(): void {
        super.destroy();
    }
}